export default __webpack_public_path__ + "static/media/arrow-up.9dbe65ee.svg";